export default __webpack_public_path__ + "static/media/4.c12704dc.jpg";